import axios from "axios";

import { geoBoundaryDataOrder, dataOrderAs } from "../../../includes/variables";

export interface IInputGeoBound {
  GeoBoundaryName: string
  GeoBoundaryTypeId: number;
  Latitude: number;
  Longitude: number;
  Radius: number;
  Address: string;
  Suburb: string;
  PostCode: string;
  IsOffroad: boolean;
  GeoPath: string;
}

interface IGeoBoundaryListParams {
  orderBy: string;
  orderAs: string;
  pageNo?: number;
  pageSize?: number;
}

export const getGeoBoundaryList = (
  orderBy = geoBoundaryDataOrder.GeoBoundaryId,
  orderAs = dataOrderAs.DESC,
  pageNo = 0,
  pageSize = 0
) => {
  let params: IGeoBoundaryListParams;

  params = { orderBy: orderBy, orderAs: orderAs };

  if (pageNo !== 0) {
    params = { ...params, pageNo: pageNo };
  }

  if (pageSize !== 0) {
    params = { ...params, pageSize: pageSize };
  }

  return axios
    .get("/ruc/v3/geography/geoboundary", {
      params: params,
    })
    .then((response) => {
      return response.data;
    })
    .catch(function (error) {
      throw error;
    });
};


export const createGeoBoundary = (geoBound: IInputGeoBound) => {

  return axios
    .post("/ruc/v3/geography/geoboundary", geoBound)
    .then((response) => {
      return response.data;
    })
    .catch(function (error) {
      throw error;
    });
};


export const updateGeoBoundary = (geoBoundaryId: string, geoBound: IInputGeoBound) => {

  return axios
    .put("/ruc/v3/geography/geoboundary/" + geoBoundaryId, geoBound)
    .then((response) => {
      return response.data;
    })
    .catch(function (error) {
      throw error;
    });
};



export const deleteGeoBoundary = (geoBoundaryId: string) => {

  return axios
    .delete("/ruc/v3/geography/geoboundary/" + geoBoundaryId)
    .then((response) => {
      return response.data;
    })
    .catch(function (error) {
      throw error;
    });
};